import React from "react";
import WarrantyCard from "../../components/WarrantyCard";
import ReportsIcon from "../../assets/reports.svg";
import CustomersAffectedIcon from "../../assets/customers-affected.svg";
import CostIcon from "../../assets/cost.svg";
import Severity from "../../assets/severity.svg";
import DtcWarrantyIcon from "../../assets/dtc-warranty-score.svg";
import RiskAnalysisIcon from "../../assets/risk-analysis.svg";
import { Link } from "react-router-dom";

const TopNonDtcComplaints = (props) => {
  const routes = props.route ? props.route : "diagnostics";
  return (
    <div
      className="diagnostics-topdtc-complaints page-wrapper"
      style={{ backgroundColor: "#EEEEEE" }}
    >
      <div className="first-container">
        <Link
          to={`/warranty-management/${routes}/top-10-non-DTC-complaints/reports`}
        >
          <WarrantyCard
            img={ReportsIcon}
            backgroundColor="#fff"
            text="Reports"
          />
        </Link>
        {/* <WarrantyCard
          img={CustomersAffectedIcon}
          backgroundColor="#fff"
          text="Customers Affected"
        /> */}
        <Link
          to={`/warranty-management/${routes}/top-10-non-DTC-complaints/cost`}
        >
          <WarrantyCard img={CostIcon} backgroundColor="#fff" text="Cost" />
        </Link>
        <Link
          to={`/warranty-management/${routes}/top-10-non-DTC-complaints/severity`}
        >
          <WarrantyCard img={Severity} backgroundColor="#fff" text="Severity" />
        </Link>
      </div>
      <div className="second-container">
        <Link
          to={`/warranty-management/${routes}/top-10-non-DTC-complaints/score-card`}
        >
          <WarrantyCard
            img={DtcWarrantyIcon}
            backgroundColor="#fff"
            text="DTC Warranty Scorecard"
          />
        </Link>
        <Link
          to={`/warranty-management/${routes}/top-10-non-DTC-complaints/risk-analysis`}
        >
          <WarrantyCard
            img={RiskAnalysisIcon}
            backgroundColor="#fff"
            text="Risk Analysis and Required Action"
            containerStyles={{ paddingTop: "20px" }}
          />
        </Link>
      </div>
    </div>
  );
};

export default TopNonDtcComplaints;
